import { z } from 'zod';
import { platformApprovedActionProviderDescriptorV2Schema, platformApprovedActionProviderRequestV2Schema, platformApprovedActionProviderResultV2Schema, platformApprovedActionProviderSlot, platformReceiptBoundActionProviderHostCapability, } from '@crest/platform-contracts/hosts';
/** The note action family is intentionally separate from the Project writer. */
export const projectsAssistantNoteActionProviderId = 'projects.assistant-note-actions';
export const projectsAssistantNoteActionProviderCapability = 'projects.assistant-note-actions.v1';
export const projectsAssistantNoteActionSlot = platformApprovedActionProviderSlot;
export const projectsAssistantProjectNoteCreateActionId = 'projects.project-note-create.v1';
export const projectsAssistantProjectNoteCreateInputSchema = z.strictObject({
    targetProjectId: z.string().uuid(),
    content: z.string().trim().min(1).max(20_000),
});
// Recomputed and pinned by the contract test. Changing this requires a new action version.
export const projectsAssistantProjectNoteCreateInputSchemaHash = 'aab09a2c05d1c32fbc68466e741b4edfc228f70d2243e33731591615b79ed456';
export const projectsAssistantArchiveCreatedProjectNoteActionId = 'projects.archive-assistant-created-project-note.v1';
export const projectsAssistantArchiveCreatedProjectNoteInputSchema = z.strictObject({
    targetNoteId: z.string().uuid(),
    originalExecutionId: z.string().uuid(),
    expectedRevision: z.number().int().positive().max(2_147_483_646),
    reason: z.string().trim().min(5).max(2_000),
    compensationSummary: z.string().trim().min(1).max(500),
});
export const projectsAssistantArchiveCreatedProjectNoteInputSchemaHash = '9ed215605385bd66289c941cf3435ce23ce7189a0ff5f0e5eb934cbe748f0b2b';
export const projectsAssistantNoteActionProviderDescriptor = platformApprovedActionProviderDescriptorV2Schema.parse({
    kind: 'descriptor',
    contractVersion: platformReceiptBoundActionProviderHostCapability,
    providerId: projectsAssistantNoteActionProviderId,
    providerCapability: projectsAssistantNoteActionProviderCapability,
    displayName: 'Projects approved note actions',
    actions: [{
            actionId: projectsAssistantProjectNoteCreateActionId,
            displayName: 'Create internal Project note',
            targetResourceType: 'projects.project',
            inputSchemaHash: projectsAssistantProjectNoteCreateInputSchemaHash,
            requiredPermission: 'projects.notes.create',
            assistantPolicy: {
                policyContractVersion: 'platform.assistant-action-policy.v1',
                confirmation: 'explicit',
                effectClass: 'compensating-write',
                externalEffectClass: 'none',
                reversal: {
                    kind: 'compensating-action',
                    registeredReversalActionId: projectsAssistantArchiveCreatedProjectNoteActionId,
                },
                ownerReadbackRequired: true,
                inputSchemaHash: projectsAssistantProjectNoteCreateInputSchemaHash,
            },
        }, {
            actionId: projectsAssistantArchiveCreatedProjectNoteActionId,
            displayName: 'Archive Assistant-created Project note',
            targetResourceType: 'projects.project-note',
            inputSchemaHash: projectsAssistantArchiveCreatedProjectNoteInputSchemaHash,
            requiredPermission: 'projects.notes.delete',
            assistantPolicy: {
                policyContractVersion: 'platform.assistant-action-policy.v1',
                confirmation: 'explicit',
                effectClass: 'compensating-write',
                externalEffectClass: 'none',
                reversal: { kind: 'compensating-action', registeredReversalActionId: null },
                ownerReadbackRequired: true,
                inputSchemaHash: projectsAssistantArchiveCreatedProjectNoteInputSchemaHash,
            },
        }],
});
export const projectsAssistantNoteActionProviderRequestSchema = platformApprovedActionProviderRequestV2Schema;
export const projectsAssistantNoteActionProviderResultSchema = platformApprovedActionProviderResultV2Schema;
//# sourceMappingURL=projects-assistant-note-actions.contract.js.map